import React from 'react';
import { T } from '../../../traks';
import API from '../../../API';


export const validateFields = ({ name, email, phoneNumber, country, postalCode, streetAddress, city, selectedPaymentMethod, ean, cvr, hasAcceptedTradeConditions }) => {
  const newErrors = {};
  if (!name.trim()) newErrors.name = <T>Name is required</T>;
  if (!email.trim()) newErrors.email = <T>E-mail address is required</T>;
  if (!phoneNumber.trim()) newErrors.phoneNumber = <T>Phone Number is required</T>;
  if (!country.trim()) newErrors.country = <T>Country is required</T>;
  if (!postalCode.trim()) newErrors.postalCode = <T>Postal Code is required</T>;
  if (!streetAddress.trim()) newErrors.streetAddress = <T>Street Address is required</T>;
  if (!city.trim()) newErrors.city = <T>City is required</T>;
  if (!hasAcceptedTradeConditions) newErrors.tradeConditions = <T>You need to accept the trade conditions</T>;
  if (selectedPaymentMethod === 'ean') {
    if (!ean.trim()) newErrors.ean = <T>EAN is required</T>;
    if (!cvr.trim()) newErrors.cvr = <T>CVR is required</T>;
  }
  return newErrors;
};
  export const createOrderObject = (defaultCurrency, vatRate, cart) => ({
    currency: defaultCurrency,
    lines: [
      {
        quantity: 1,
        vatrate: 0,
        description: `Køb af ${cart.lines[0].keys} nøgler i ${cart.lines[0].months} måneder`,
        instantcapture: true,
        unitprice: Number((cart.lines[0].discountedTotal * 100).toFixed(2)),
      }
    ]
  });
  
  export const createPaymentObject = (orderId, formValues, cart) => ({
    name: formValues.name,
    company: formValues.company,
    email: formValues.email,
    phoneNumber: formValues.phoneNumber,
    country: formValues.country,
    postalCode: formValues.postalCode,
    streetAddress: formValues.streetAddress,
    city: formValues.city,
    orderId: orderId,
    status: 'Created',
    paymentMethod: formValues.selectedPaymentMethod,
    ean: formValues.ean,
    cvr: formValues.cvr,
    order: {
      num_keys: cart.lines[0].keys,
      num_months: cart.lines[0].months,
      total_price: Number(cart.lines[0].discountedTotal),
      start_date: cart.lines[0].startDate + 'T00:00:00Z',
      game: cart.lines[0].game,
    }
  });


export const requestOrderId = async (orderObject) => {
  return new Promise((resolve, reject) => {
    API.post('/z/get_order_id', orderObject, (response, status) => {
      if (status === 200) resolve(response.orderId);
      else reject(new Error('Failed to retrieve order ID.'));
    });
  });
};
    
export const createPayment = async (paymentObject, gameId) => {
  return new Promise((resolve, reject) => {
    API.post('/a/create_order', {...paymentObject, gameId}, (response, status) => {
      if (status === 200) resolve(response.paymentId);
      else reject(new Error('Failed to create payment.'));
    });
  });
};


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/CheckoutUtils.js